import { inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Company, UserGroup } from 'depoto-core/src/entities'
import { CoreService } from '../core.service'

@Injectable({ providedIn: 'root' }) // todo do i need this
export class UserGroupService {
  private http = inject(HttpClient)
  core = inject(CoreService)

  public async getUserGroup(
    id,
    schema = {
      id: null,
      name: null,
      roles: [null],
      company: {
        id: null,
        name: null,
      },
    }
  ): Promise<UserGroup> {
    return new UserGroup(await this.core.services.userGroup.getById(id, schema))
  }

  async getUserGroups(
    parameters: any = {
      sort: 'name',
      direction: 'asc',
    },
    schema: any = { id: null, name: null, roles: null, company: { id: null, name: null } }
  ): Promise<{
    items: UserGroup[]
    paginator: { current: null; endPage: null; totalCount: null }
  }> {
    return await this.core.services.userGroup.getList(parameters, schema)
  }

  createUserGroup(userGroup: Partial<UserGroup>, schema: Partial<UserGroup>): Promise<UserGroup> {
    // createUserGroup(userGroup: Partial<UserGroup>, schema: UserGroup | Partial<UserGroup>): Promise<UserGroup> {
    return this.core.services.userGroup.create(userGroup, schema)
  }

  updateUserGroup(userGroup: Partial<UserGroup>, schema: Partial<UserGroup>): Promise<UserGroup> {
    // updateUserGroup(userGroup: Partial<UserGroup>, schema: UserGroup | Partial<UserGroup>): Promise<UserGroup> {
    return this.core.services.userGroup.update(userGroup, schema)
  }

  deleteUserGroup(userGroup: Partial<UserGroup>): Promise<UserGroup> {
    return this.core.services.userGroup.delete(userGroup)
  }
}
